// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".MuiDialog-paperWidthSm{max-width:550px !important}", "",{"version":3,"sources":["webpack://./src/components/TakeInOutDialog/styles.scss"],"names":[],"mappings":"AAAA,wBACE,0BAAA","sourcesContent":[".MuiDialog-paperWidthSm {\n  max-width: 550px !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
